import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { mountPoint, onLeave } from "./boot";
import "./styles.css";
import "./chat.css";
import "./shell.css";
import "./kit.css";

const root = createRoot(mountPoint());
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
onLeave(() => root.unmount());
